<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big">
            {{ 'UPLOADER_MODAL_UNKOWN_UPLOAD_ERROR_TITLE' | translate }}
        </div>
    </div>
    <div class="body">
        <div class="section">
            <p>
                {{ 'UPLOADER_MODAL_UNKOWN_UPLOAD_ERROR_DESCRIPTION' | translate }}
            </p>
        </div>
        <div class="section">
            <div>
                <u>Name</u> : {{ errorName }}
            </div>
            <div>
                <u>Message</u> : {{ errorMessage }}
            </div>
            <div>
                <u>RequestId</u> : {{ requestId }}
            </div>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new red" (click)="retry()">{{
            'UPLOADER_MODAL_UNKOWN_UPLOAD_ERROR_BUTTON_LABEL_RETRY' | translate }}</button>
    </div>
</div>